import React from 'react';
import s from '../PaperworkList.module.css';
import style from '../../CreationOfDesign/CreationOfDesign.module.css';
import {Link} from 'react-router-dom';
import VeryLightGreenButton from '../../../Components/Buttons/VeryLightGreenButton';
import ButtonPlusElement from '../../../Components/Buttons/ButtonPlusElement';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';

const CreateLinkButtons: React.FC = () => {
	const {t} = useTranslation();
	return (
		<div className={s.greenButtonsWrapper}>
			<div className={style.typeInvoiceSelectRight}>
				<Link to={'/creation_of_design'}>
					<VeryLightGreenButton
						text={t('створити оформлення')}
						type={'button'}
					/>
					<ButtonPlusElement />
				</Link>
			</div>
			<div className={style.typeInvoiceSelectRight}>
				<Link to={'/create_cash_order'}>
					<LightGreenButton text={t('створити оплату')} type={'button'} />
					<ButtonPlusElement />
				</Link>
			</div>
		</div>
	);
};

export default CreateLinkButtons;
